<template functional>
  <b-container fluid class="user-container">
    <b-row class="d-none d-sm-flex">
      <div
        v-for="(column, key) in props.columns"
        :class="['col', props.sizes ? `col-sm-${props.sizes[key]} ` : 'col-sm', 'font-weight-bold']"
        :key="key"
      >
        {{ column }}
      </div>
    </b-row>
    <slot name="table-body"></slot>
  </b-container>
</template>

<script>
export default {
  name: 'VTable',
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    sizes: {
      type: Array,
      default: null,
    },
  },
};
</script>

<style scoped lang="scss">
.user-container {
  & > /deep/ div {
    padding: 1em 0;

    &:not(:last-child) {
      border-bottom: 1px solid #dee2e6;
    }
  }
}
</style>
